import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import { m } from "@/paraglide/messages";

/**
 * On-page editorial content for the F1 Fantasy landing page: what the tools
 * do, how the predictions work, and an FAQ. Real text so the page is not a
 * bare app shell (AdSense/search quality).
 */
export function F1SeoContent() {
  const tools = [
    {
      title: m.f1_seo_apex_title(),
      body: m.f1_seo_apex_body(),
      to: "/f1-fantasy/apex-team",
    },
    {
      title: m.f1_seo_budget_title(),
      body: m.f1_seo_budget_body(),
      to: "/f1-fantasy/budget-boost",
    },
    {
      title: m.f1_seo_stats_title(),
      body: m.f1_seo_stats_body(),
      to: "/f1-fantasy/statistics",
    },
    {
      title: m.f1_seo_standings_title(),
      body: m.f1_seo_standings_body(),
      to: "/f1-fantasy/standings",
    },
    {
      title: m.f1_seo_points_title(),
      body: m.f1_seo_points_body(),
      to: "/f1-fantasy/fantasy-points",
    },
  ];

  const faqs = [
    { q: m.f1_faq1_q(), a: m.f1_faq1_a() },
    { q: m.f1_faq2_q(), a: m.f1_faq2_a() },
    { q: m.f1_faq3_q(), a: m.f1_faq3_a() },
    { q: m.f1_faq4_q(), a: m.f1_faq4_a() },
    { q: m.f1_faq5_q(), a: m.f1_faq5_a() },
  ];

  return (
    <section className="max-w-3xl mx-auto px-5 py-10 md:py-14 space-y-10">
      <div className="space-y-3">
        <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
          {m.f1_seo_title()}
        </h2>
        <p className="leading-relaxed text-muted-foreground">{m.f1_seo_p1()}</p>
        <p className="leading-relaxed text-muted-foreground">{m.f1_seo_p2()}</p>
      </div>

      <div className="space-y-6">
        <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
          {m.f1_seo_tools_title()}
        </h2>
        {tools.map((t) => (
          <div key={t.to} className="space-y-2">
            <h3 className="text-lg font-semibold tracking-tight">{t.title}</h3>
            <p className="leading-relaxed text-muted-foreground">{t.body}</p>
            <Link
              to={t.to}
              className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline"
            >
              {m.f1_seo_tool_cta()}
              <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        ))}
      </div>

      <div className="space-y-3">
        <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
          {m.f1_seo_method_title()}
        </h2>
        <p className="leading-relaxed text-muted-foreground">
          {m.f1_seo_method_p1()}
        </p>
        <p className="leading-relaxed text-muted-foreground">
          {m.f1_seo_method_p2()}
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
          {m.f1_faq_title()}
        </h2>
        <dl className="space-y-3">
          {faqs.map((f) => (
            <div
              key={f.q}
              className="rounded-xl border border-border bg-card/40 p-4"
            >
              <dt className="font-semibold text-foreground">{f.q}</dt>
              <dd className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
                {f.a}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
